import { render, staticRenderFns } from "./CompanyTask.vue?vue&type=template&id=bf5238c8&"
import script from "./CompanyTask.vue?vue&type=script&lang=js&"
export * from "./CompanyTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports